import { Component } from 'react';
import styled from "@emotion/styled"

const ShinglePreview = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 14%);
  padding-bottom 56.25%;
  position: relative;
  display: inline-block;
  padding-bottom: 62.5%;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 1em;
  }
`;

const ViewToggle = styled.a`
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: inline-block;
  font-size: 0.75em;
  padding: 0.833em;
  position: absolute;
  right: 15px;
  text-decoration: none;
  top: 0;
  transition: all 0.15s ease-in-out;
  whitespace: nowrap;
  z-index: 10;

  &:hover {
    background-color: #000000;
    color: #FFFFFF;
  }
`;

export default class ImageView extends Component {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
    this.onZoom = this.onZoom.bind(this);
  }

  onZoom() {
    this.props.onZoom(this.props.shingleColor);
  }

  onToggle() {
    this.props.onToggle(
      this.props.selectedView === 'shingle' ? 'house' : 'shingle'
    );
  }

  render() {
    var houseStyleImageMapping = {
      "default": this.props.shingleColor.house_1229x768_url2,
      "ranch": this.props.shingleColor.ranch_house_image_url,
      "two-story-1": this.props.shingleColor.two_story_house_v1_image_url,
      "two-story-2": this.props.shingleColor.two_story_house_v2_image_url
    }

    var previewBackgroundImageUrl = this.props.selectedView === 'shingle'
      ? this.props.shingleColor.swatch_768x485_url
      : houseStyleImageMapping[this.props.selectedStyle];

    previewBackgroundImageUrl ||= houseStyleImageMapping["default"];

    return (
      <div className={`multiview xs-mbl ${this.props.className || ''}`}>
        <ShinglePreview
          className="img-responsive multiview__image jsSwatchView"
          key={this.props.shingleColor.uid}
          style={{
            backgroundImage: `url(${previewBackgroundImageUrl})`
          }}
        />
        <ViewToggle onClick={this.onToggle}>
          {this.props.selectedView === 'shingle' ? 'House' : 'Shingle'} View
        </ViewToggle>
      </div>
    );
  }
}
